<template>
  <SheetModal
    class="ScheduleRunModalView"
    data-theme="light"
    aria-label="New run"
    :aria-busy="isRequesting || isSaving"
    @close="$emit('close')"
  >
    <RunFormView
      v-model:isRequesting="isRequesting"
      title="Schedule a run"
      @cancel="$emit('close')"
      @submit="handleSubmit"
    />
  </SheetModal>
</template>

<script lang="ts" setup>
import SheetModal from "@/components/SheetModal.vue";
import { supabaseClient } from "@/lib/database/supabase";
import getRouteForRun from "@/lib/utils/route/getRouteForRun";
import useModalStore from "@/stores/useModalStore";
import useRunCarouselStore from "@/stores/useRunCarouselStore";
import useSeasonStore from "@/stores/useSeasonStore";
import RunFormView from "@/views/commish/RunFormView.vue";
import { InsertRunWithCrewsArgs } from "@shared/lib/database/function.types";
import { ref } from "vue";

defineEmits<{
  close: [],
}>();

const {
  replaceModal,
} = useModalStore();

const {
  fetchRun,
} = useRunCarouselStore();

const {
  fetchSeason,
} = useSeasonStore();

const isRequesting = ref(true);
const isSaving = ref(false);

async function handleSubmit (payload: InsertRunWithCrewsArgs | undefined) {
  if (!payload) return;

  isSaving.value = true;

  const {
    data: _run,
    error,
  } = await supabaseClient.rpc("insert_run_with_crews", payload);

  if (error) {
    alert(error.message);
  } else {
    // TODO: shouldn’t need to fetch these here
    // if there’s a better way to update the rest of the app
    // Also, DRY between here and EditRunModalView
    fetchRun(_run.id);
    if (_run.season_id) fetchSeason(_run.season_id);

    replaceModal(getRouteForRun(_run.id));
  }

  isSaving.value = false;
}
</script>
